// extracted by mini-css-extract-plugin
export var container = "_75-0";
export var infoButton = "_75-1";
export var label = "_75-3";
export var labelExpanded = "_75-4";
export var price = "_75-5";
export var priceExpanded = "_75-6";
export var title = "_75-2";